import React from "react";
import styles from "./styles.module.scss";
export interface Props {
  onClick: (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent> | undefined
  ) => void;
}

const BackButton = ({ onClick }: Props) => {
  return (
    <div className={styles.container}>
      <a className={styles.link} onClick={(e) => onClick(e)}>
        <img alt="back" src="/assets/images/svg/back.svg" />
      </a>
    </div>
  );
};

export default BackButton;
